import { render, staticRenderFns } from "./RenderizaFormModosComponent.vue?vue&type=template&id=dc06f6c2&scoped=true"
import script from "./RenderizaFormModosComponent.vue?vue&type=script&lang=js"
export * from "./RenderizaFormModosComponent.vue?vue&type=script&lang=js"
import style0 from "./RenderizaFormModosComponent.vue?vue&type=style&index=0&id=dc06f6c2&prod&scoped=true&lang=css"
import style1 from "./RenderizaFormModosComponent.vue?vue&type=style&index=1&id=dc06f6c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06f6c2",
  null
  
)

export default component.exports